import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-informations-text-block',
  templateUrl: './informations-text-block.component.html',
})
export class InformationsTextBlockComponent {
  @Input() content: any;
}
